<template>
    <PlaceholderPage :title="t.placeholder.gamificationTitle" :subtitle="t.placeholder.gamificationSubtitle" />
</template>

<script>
import PlaceholderPage from './PlaceholderPage.vue';
import { corporateI18n } from '@/i18n/mixins';

export default {
    name: 'CorporateGamification',
    mixins: [corporateI18n],
    components: { PlaceholderPage },
};
</script>
